<template>
  <ButtonGroup :color="color">
    <Btn :color="color" :size="size" @click="$emit('select')" data-test-id="split-button-main-action">
      <slot />
    </Btn>
    <PopoverMenu>
      <template #trigger>
        <Btn :color="color" :size="size" icon data-test-id="button-addon-action">
          <ChevronDownIcon16 />
        </Btn>
      </template>

      <template #items-list>
        <slot name="popoverContent" />
      </template>
    </PopoverMenu>
  </ButtonGroup>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Btn from '@/components/common/Btn.vue';
import ButtonGroup from '@/components/common/ButtonGroup.vue';
import ChevronDownIcon16 from '@/components/Icons/ChevronDownIcon16.vue';

export default defineComponent({
  name: 'SplitBtn',

  emits: { select: null },

  components: {
    Btn,
    ButtonGroup,
    ChevronDownIcon16,
  },

  props: {
    color: ButtonGroup.props.color,

    size: Btn.props.size,
  },
});
</script>
